'use client';

import React from 'react';

import { SimpleGrid, VStack } from '@chakra-ui/react';

import { Loader } from '@components/custom-loader';
import { CustomText } from '@components/Custom-text';
import { useGetPlansQuery } from '@modules/pricing/api';

import PricingCard from '../cards/PricingCard';

const PricingView = () => {
    const { data, isFetching } = useGetPlansQuery();
    return (
        <VStack py={5} px={{ base: 1, sm: 5, md: 10, lg: 100 }} h="100%" w="100%">
            <VStack>
                <CustomText color="mainText" size="xl" weight={600}>
                    Choose your Plan
                </CustomText>
                <CustomText color="mainText" size="md">
                    Empower Yourself with the Right Plan. This is the best time to get started.
                </CustomText>
            </VStack>
            {isFetching ? (
                <Loader height="70vh" width="100%" size="lg" />
            ) : (
                <SimpleGrid
                    columns={{ base: 1, sm: 2, md: 2, lg: 3, xl: 3 }}
                    spacing="25px"
                    marginTop={{ base: 0, sm: 0, md: 0, lg: 8, xl: 8 }}
                    marginBottom={30}
                >
                    {data &&
                        data.plans &&
                        data.plans?.length > 0 &&
                        data.plans.map(plan => (
                            <PricingCard
                                key={plan?.id}
                                id={plan?.id}
                                name={plan?.name ?? '-'}
                                price={plan?.price ?? 0}
                                actualPrice={plan?.actualPrice}
                                title={plan?.description ?? ''}
                                features={plan?.features ?? []}
                                showHeader={plan?.isPopular}
                                currency={plan?.currency ?? 'INR'}
                                headerText="Most Popular Plan"
                                isAddOn={plan?.isAddon}
                            />
                        ))}
                </SimpleGrid>
            )}
        </VStack>
    );
};

export default PricingView;
